import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function ConfirmDialog({ open, title, description, confirmLabel, onConfirm, onClose, testid = "confirm-dialog" }) {
  const { t } = useAuth();
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="card-bg border-app" data-testid={testid}>
        <DialogHeader>
          <DialogTitle className="font-heading">{title}</DialogTitle>
          <DialogDescription className="t-secondary">{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button variant="outline" className="border-app" onClick={onClose} data-testid={`${testid}-cancel`}>
            {t("confirm.cancel")}
          </Button>
          <Button className="bg-rose-600 hover:bg-rose-700 text-white" onClick={onConfirm} data-testid={`${testid}-confirm`}>
            {confirmLabel || t("confirm.delete")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
